import TemplateInteractiveEditor from "./templateInteractiveEditor.container";
export default TemplateInteractiveEditor;
